import initialBookingStateSelector from '../Booking/selectors/InitialBookingStateSelector';

const privateWhitelabelDirectoryIdStrings = [
    '764', // https://www.zocdoc.com/wl/testhospital123/search
    '1095', // https://www.zocdoc.com/wl/mshscovid19vaccine/search
    '1136', // St. Peters vaccine WL
    '1184', // St. Peters Monroe
    '1137', // Stamford Health https://www.zocdoc.com/wl/stamfordcovid19vaccination/search
    '1141', // Stamford employee
    '1139', // Valley
    '1138', // Montefiore
    '1151', // Erie Chicago
    '1152', // Erie Waukegan
    '1183', // Erie Evanston
    '1153', // Esperanza
    '1169', // Princeton
    '1172', // Tufts
    '1149', // Test Vaccine Single Use URL
    '1175', // Community Nursing Services
    '1182', // King Kullen
    '1187', // Loretto
    '1188', // Tufts 2
    '1189', // Baycare 1
    '1190', // Baycare 2
    '1327', // Sinai 3rd Shot
    '1332', // Valley 3rd Shot
    '1339', // Stamford Employee Booster
    '1340', // Stamford Health Booster (general public)
    '1437', // Stamford Booster Dose 2
    '1349', // Saint Peters Booster
    '1351', // Valley Moderna
    '1354', // Sinai Pediatric
    '1355', // CoreLife Pasadena
    '1356', // CoreLife Towson
    '1357', // CoreLife Bowie
    '1358', // CoreLife Gaithersburg
    '1359', // Valley Kids
    '1364', // Stamford Kids
];

export function isPrivateWhiteLabel(directoryId) {
    const stringDirectoryId = (directoryId || '').toString();
    // hardcoded monolith ids for white labels;
    // if we add something in the tool later on we can flip this to look at that...
    return (
        typeof directoryId !== 'undefined' &&
        privateWhitelabelDirectoryIdStrings.includes(stringDirectoryId)
    );
}

export function isBookingStateForPrivateWhiteLabel(state) {
    const initialBookingState = initialBookingStateSelector(state);
    const directoryId = initialBookingState?.directoryId || -1;
    return isPrivateWhiteLabel(directoryId);
}
